var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Section',{staticClass:"rich-text",attrs:{"width":_vm.width,"background":'bg-' + _vm.background}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$prismic.asHtml(_vm.content))}})])}
var staticRenderFns = []

export { render, staticRenderFns }